import { getOfflineAuthor } from '../1-common/utils/author';
import { EPNodeFieldsResolvers } from '../5-node/fields';
const EPAnswerHistoryItemFieldsResolver = {
    async author() {
        return getOfflineAuthor();
    },
    async review() {
        return null;
    }
};
function lastHistoryItem(parent) {
    const history = parent.answerHistory;
    return history?.[history.length - 1];
}
const EPAnswerDataFieldsResolver = {
    latestAnswer(parent) {
        return lastHistoryItem(parent) ?? null;
    },
    answerHistoryCount(parent) {
        return parent.answerHistoryCount ?? parent.answerHistory?.length ?? 0;
    },
};
export const epAnswerFieldsResolvers = {
    EPAnswer: EPNodeFieldsResolvers,
    EPAnswerData: EPAnswerDataFieldsResolver,
    EPAnswerHistoryItem: EPAnswerHistoryItemFieldsResolver,
};
